import { Navigate, Outlet } from 'react-router-dom';
import { RoutePaths } from './RoutePaths';
import { EmployerPageLayout, ToolsPageLayout } from '../components';
import {
    useAppDispatch,
    useAppSelector,
    isLoggedIn,
    isToolsPage,
} from '../base';
import { loginActions, userSelectors } from '../actions';
import { LoadingPage } from '../pages';

const AuthLayout = () => {
    const dispatch = useAppDispatch();
    const isAuthenticated = isLoggedIn();
    const myUser = useAppSelector(userSelectors.getMyUser);

    if (isAuthenticated && !myUser) {
        dispatch(loginActions.fetchInitialData());
    }

    const renderAuthenticatedRoute = () => {
        if (!myUser) {
            return <LoadingPage />;
        }
        if (myUser && !myUser.company?.id) {
            return <Navigate to={RoutePaths.chat} replace />;
        }
        if (isToolsPage()) {
            return (
                <ToolsPageLayout>
                    <Outlet />
                </ToolsPageLayout>
            );
        }
        return (
            <EmployerPageLayout>
                <Outlet />
            </EmployerPageLayout>
        );
    };

    return isAuthenticated ? (
        renderAuthenticatedRoute()
    ) : (
        <Navigate to={RoutePaths.login} replace />
    );
};

export default AuthLayout;
